import styled from "styled-components";

import { FlexDiv } from "@/components/Atoms/Box";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";

import Typography from "@/foundation/Typography/V2";
import theme from "@/foundation/Theme";

export const SectionIconWrapper = styled(FlexDiv)`
  justify-content: center;
  align-items: center;
  height: 32px;
  width: 32px;
  border-radius: 50%;
  background-color: ${theme.colorsV2.blueGray.shade_100};
`;

export const SectionIcon = styled(StyledSvgSprite)`
  height: 16px;
  width: 16px;
  stroke: ${theme.colorsV2.blueGray.shade_900};
`;

export const SectionTitle = styled(Typography)`
  color: ${theme.colorsV2.blueGray.shade_700};
  flex: 1;
`;

export const SectionWrapper = styled(FlexDiv)`
  cursor: pointer;
  align-items: center;
  gap: 24px;
  &:hover {
    ${SectionIconWrapper} {
      background-color: ${theme.colorsV2.shyft.purple_text};
    }
    ${SectionIcon} {
      stroke: ${theme.colors.white};
    }
    ${SectionTitle} {
      color: ${theme.colorsV2.shyft.purple_text};
    }
  }
`;
